export const site = {
  brand: "CHRISJSTPERFORMANCE",
  email: "Cjsteinh@outlook.com",
  igHandle: "@chrisjstperformance",
  igUrl: "https://instagram.com/chrisjstperformance",
  tiktokHandle: "@chrisjstperformance",
  tiktokUrl: "https://www.tiktok.com/@chrisjstperformance",
  images: {
    hero: "https://images.pexels.com/photos/28425857/pexels-photo-28425857.jpeg",
    car: "https://images.unsplash.com/photo-1536909526839-8f10e29ba80c",
    gym: "https://images.unsplash.com/photo-1676655079738-af54dfd6318e",
    equipment: "https://images.pexels.com/photos/14963236/pexels-photo-14963236.jpeg",
    neon: "https://images.unsplash.com/photo-1576564081868-0fb07ce0b63c",
    track: "https://images.pexels.com/photos/11233115/pexels-photo-11233115.jpeg?auto=compress&cs=tinysrgb&w=1260",
  },
  nav: [
    { label: "MANIFESTO", href: "#manifesto" },
    { label: "PROGRAMS", href: "#programs" },
    { label: "RESULTS", href: "#results" },
    { label: "COACH", href: "#coach" },
    { label: "FAQ", href: "#faq" },
    { label: "CONTACT", href: "#contact" },
  ],
  marquee: [
    "STRENGTH",
    "CONDITIONING",
    "MOBILITY",
    "REACTION SPEED",
    "HEAT TOLERANCE",
    "CORE STABILITY",
    "RECOVERY",
    "RACE DAY READY",
  ],
  chapters: [
    {
      num: "01",
      title: "Train for the cockpit, not the mirror.",
      body: "Every session is built around what the car demands of you: neck and core stability under sustained load, reaction speed, heat tolerance, and the conditioning to stay sharp in the final stint. Nothing in the program is decoration — everything transfers to the seat.",
      image: "gym",
    },
    {
      num: "02",
      title: "Tested with data, not guesses.",
      body: "Regular performance testing tracks your strength, conditioning, and coordination work, so the program adjusts to real numbers instead of feelings. You always know exactly where you stand — and what the next block is building toward.",
      image: "car",
    },
    {
      num: "03",
      title: "Built around your season.",
      body: "Pre-race build-ups, mid-week maintenance, post-race recovery blocks. Your calendar drives the plan, so you peak when the lights go out — not three weeks after the checkered flag.",
      image: "track",
    },
  ],
  tiers: [
    {
      id: "tier-1",
      tag: "TIER 1",
      name: "Starter Driver Coaching",
      price: 150,
      blurb: "Structure and a race-focused program for drivers who don't need high-touch coaching yet.",
      features: [
        "Custom motorsport-specific training plan: strength, conditioning, mobility, and core stability for drivers",
        "Program delivered through the training app with exercises, sets/reps, and progress tracking",
        "Weekly check-ins to review training, answer questions, and make light adjustments",
        "Basic form feedback via messages and video when needed",
      ],
      ideal: "Younger kart and club drivers, budget-conscious racers who want structure.",
    },
    {
      id: "tier-2",
      tag: "TIER 2 — MAIN TIER",
      name: "Performance Driver Coaching",
      price: 250,
      blurb: "Train year-round like a racing athlete, not a gym-goer. Built around your races, tested with real performance metrics, adjusted as your season changes.",
      features: [
        "Everything in Tier 1, plus deeper customization around your race calendar — pre-race, mid-week, and post-race recovery blocks",
        "Regular performance testing across strength, conditioning, and reaction/coordination work",
        "Nutrition guidance to fuel training blocks, race weekends, and recovery",
        "Video form reviews to refine technique on key lifts and movement patterns",
        "Priority messaging support for travel, race changes, and on-the-fly adjustments",
        "Monthly or bi-weekly check-ins to review results, tweak the plan, and set the next performance goals",
      ],
      ideal: "Serious competitors actively racing who want a proper performance program, not just workouts.",
      highlight: true,
    },
    {
      id: "tier-3",
      tag: "TIER 3",
      name: "Elite Driver Coaching",
      price: 400,
      blurb: "The highest level of access and customization for packed calendars and pro-level targets.",
      features: [
        "Everything in Tier 2, plus the highest level of access and customization",
        "Full program built entirely around your race schedule, travel, sim work, and off-track demands",
        "Weekly 1:1 calls or video check-ins covering performance, fatigue, and upcoming races",
        "Unlimited messaging support for ongoing questions and race-week troubleshooting",
        "Advanced program tweaks: heat tolerance strategies, season-long periodization, detailed recovery monitoring",
        "Team performance support available — individualized driver programming, race-calendar planning, and consistent physical preparation standards across your lineup",
      ],
      ideal: "Drivers managing demanding race schedules, athletes targeting professional level performance, and teams seeking a structured, motorsports-specific physical preparation system for their driver lineup.",
    },
  ],
  testimonials: [
    {
      quote: "I am able to drive 25 mins non stop, which before was simply impossible.",
      name: "Irving A.",
      role: "Karting Driver",
    },
    {
      quote: "Already seeing good muscular results!",
      name: "Arvin N.",
      role: "Autocross & Endurance Driver",
    },
    {
      quote: "My VO2 Max has increased to 50, which shows an improvement on my heart.",
      name: "Anonymous",
      role: "Karting Driver",
    },
    {
      quote: "The workouts can be challenging but are worth it!",
      name: "Darrell H.",
      role: "Sim & Future GT Driver",
    },
    {
      quote: "I can see physical and racing progress with the kids.",
      name: "Salim H.",
      role: "97one Racing Team — Karting",
    },
  ],
};
